import React, {memo} from 'react';

import ArrowRight from '../images/arrow_right.svg';

import {styleMods} from '../utils';
import Prng from '../utils/prng';

import style from './striped-teaser.module.scss';
import Columns from './columns';
import Link from './link';
import StripedBox from './striped-box';

export default memo(
	/**
	 * @param {{
	 *   hashState: number,
	 *   url?: string,
	 *   left?: React.ReactNode,
	 *   headline?: React.ReactNode,
	 *   children?: React.ReactNode,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function StripedTeaser({hashState, url, left, headline, children}) {
		const prng = new Prng(hashState);

		const colors = prng.shuffledStripesColors();

		const content = (
			<Columns>
				<div className={style.left}>
					<StripedBox
						className={style.leftBgBox}
						color={colors[0]}
						style={{
							left: `${prng.range(-2, 3)}%`,
							top: `${prng.range(10, 15)}%`,
						}}
					/>

					<StripedBox
						className={style.leftBgBox}
						color={colors[1]}
						style={{
							left: `${prng.range(10, 15)}%`,
							top: `${prng.range(-15, -10)}%`,
						}}
					/>

					{left && (
						<div className={style.leftContent}>
							{left}
						</div>
					)}
				</div>

				<div className={style.right}>
					{headline && (
						<h1 className={style.headline}>{headline}</h1>
					)}

					{children && (
						<div className={style.rightContent}>{children}</div>
					)}

					{url && (
						<ArrowRight className={style.more} />
					)}
				</div>
			</Columns>
		);

		const content2 = (() => {
			if (url) {
				return (
					<Link href={url} className={style.link}>
						{content}
					</Link>
				);
			} else {
				return content;
			}
		})();

		return (
			<div
				className={styleMods(style, 'base', {
					isLinked: !!url,
					hasHeadline: !!headline,
					hasLeftContent: !!left,
					hasRightContent: !!children,
				})}
			>
				{content2}
			</div>
		);
	}
);
